import React from "react";

// Matches both http and https URLs
const URL_REGEX = /(https?:\/\/[^\s]+)/g;

/**
 * Splits message text and renders URLs as clickable links.
 * Links use stopPropagation so clicking them doesn't trigger parent div's onClick.
 */
export function messageWithLinks(text) {
  if (!text || typeof text !== "string") return text;
  const parts = text.split(URL_REGEX);
  return parts.map((part, i) =>
    /^https?:\/\//.test(part) ? (
      <a
        key={i}
        href={part}
        target="_blank"
        rel="noopener noreferrer"
        className="message-link"
        onClick={(e) => e.stopPropagation()}
      >
        {part}
      </a>
    ) : (
      part
    )
  );
}
